import { Product } from '@/services/models/implementations/Product.ts'

export class MissingAccessory {

  id!: string
  quantity!: number
  details?: Product
  origins: string[] = []

  public constructor(data?: Partial<MissingAccessory>) {
    Object.assign(this, data)
    this.details = new Product(data?.details)
  }
}
